module.exports = __webpack_public_path__ + "media/images/icons/document-5051fc82623224a081d28b645e489f90.svg";